// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ToolsSvg from '@rsuite/icon-font/lib/action/Tools';
var Tools = createSvgIcon({
  as: ToolsSvg,
  ariaLabel: 'tools',
  category: 'action',
  displayName: 'Tools'
});
export default Tools;